<template>
  <div id="checkout">
    <section v-show="!loading">
      <div class="payment-button-wrapper">
        <v-btn
          @click="processPayment"
          color="success"
          class="payment-button"
          ref="submitButton"
          :disabled="payButtonDisabled || !this.payButtonEnabled"
          >{{ buttonLabel }}</v-btn
        >
        <div class="payment-button__pulse"></div>
      </div>
    </section>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="green"
    ></v-progress-circular>

    <div id="card-errors" ref="paymentErrors" class="element-errors hide">
      {{ stripeValidationError }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import stripeMixin from '../../mixins/stripe';
import { appURL } from '../../config';
import { db } from '../../db';

export default {
  name: 'stripe-giropay',

  props: {
    payButtonEnabled: {
      type: Boolean,
      default: false,
    },
    orderedItem: {
      type: Object,
      default: () => {},
    },
    customerData: {
      type: Object,
      default: () => {},
    },
  },

  mixins: [stripeMixin],

  data() {
    return {
      payButtonDisabled: false,
      giropayElement: null,
      stripeValidationError: '',
      stripePaymentIntentSecret: undefined,
      loading: false,
    };
  },

  computed: {
    ...mapState(['user_data', 'userType']),
  },

  watch: {
    orderedItem(val) {
      this.updateButtonLabel(val, 'Giropay');
    },
  },

  methods: {
    async processPayment() {
      console.log('pay giro');
      this.payButtonDisabled = true;
      this.$refs.submitButton.textContent = 'Processing…';
      this.$gtm.push({ event: 'checkout', product_name: this.orderedItem.name });

      const paymentObj = {
        return_url: `${appURL}/`,
        payment_method: {
          billing_details: {
            name: this.customerData.name,
            email: this.customerData.email,
          },
        },
      };

      if (this.customerData && this.customerData.email) {
        paymentObj.receipt_email = this.customerData.email;
      }

      const newWaitingPaymentRef = db
        .collection('payments_waiting')
        .doc(this.stripePaymentIntentSecret);
      await newWaitingPaymentRef.set({
        stripe_intent_id: this.stripePaymentIntentSecret,
        account_type: this.userType,
        account_id: this.user_data.id,
        plan_details: this.orderedItem,
        payment_type: 'giropay',
        timestamp: Date.now(),
      });

      const confirmation = await this.stripe.confirmGiropayPayment(
        this.stripePaymentIntentSecret,
        paymentObj,
      );

      if (confirmation.error) {
        this.payButtonDisabled = false;
        this.stripeValidationError = confirmation.error.message;
        this.$refs.paymentErrors.classList.remove('hide');
      } else {
        this.$refs.paymentErrors.classList.add('hide');
        this.$emit('payment-successful', {
          paidPlan: this.orderedItem,
          paymentId: confirmation.paymentIntent.id,
          paidBy: 'giropay',
        });
        console.log('success');
      }
    },
  },

  async mounted() {
    this.loading = true;
    this.payButtonDisabled = true;

    const clientSecret = await this.createPaymentIntent(this.orderedItem);
    this.stripePaymentIntentSecret = clientSecret;

    this.updateButtonLabel(this.orderedItem, 'Giropay');
    this.payButtonDisabled = false;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '@/styles/blue-ring.scss';

.payment-info {
  margin: 15px auto;
  /* width: 90%; */
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 2px 3px 3px 2px rgba(0, 0, 0, 0.25);
}

.payment-button-wrapper {
  margin: 15px auto;
  width: 90%;
  position: relative;
  text-align: center;
}

.payment-button {
  // margin: 15px auto;
  width: 100%;
  padding: 8px;
  border-radius: 15px;
  @include mainLinearGradient;
  color: white;
  margin: 0 !important;
  font-weight: bold;

  &__pulse {
    @include pulse3;
    position: absolute;
    top: -1px;
    height: 40px;
    width: 100%;
    border-radius: 15px;
    pointer-events: none; // pass through click event
  }
}

.hide {
  display: none;
}
</style>
